import {
  Action,
  domen,
  existedInvocesToken,
  reloadSaveStatuses,
  saveToken,
  Trigger,
} from '../../defaults';

export const saveExistedTriggers: Trigger[] = [
  {
    events: ['on-change-any-data-param'],
    targets: [saveToken],
    handlers: ['add-save-existed-requests', 'save-existed', 'add-invoces-pending'],
    expr: {
      type: 'func',
      value: `({hashMap}) => hashMap['${saveToken}'].data.customData.saveStatus === 'valid'
        && !hashMap['${saveToken}'].data.customData['${reloadSaveStatuses['saved-existed']}']
        && !!hashMap['${existedInvocesToken}'].child.length`,
    },
  },

  {
    events: ['data-fetch-success'],
    targets: [saveToken],
    handlers: [
      'saveStatus-to-saved-existed',
      'remove-save-existed-request',
      'subtract-invoces-pending',
    ],
    expr: {
      type: 'func',
      value: `({sourceAction}) => sourceAction.token === 'save-existed'`,
    },
  },

  {
    events: ['data-fetch-error'],
    targets: [saveToken],
    handlers: [
      'remove-save-existed-request',
      'subtract-invoces-pending',
      'show-modal-error',
    ],
    expr: {
      type: 'func',
      value: `({sourceAction}) => sourceAction.token === 'save-existed'`,
    },
  },
];

export const saveExistedActions: Action[] = [
  {
    kind: 'changes',
    token: 'add-save-existed-requests',
    spec: {
      target: saveToken,
      changes: {
        [`data.customData.${reloadSaveStatuses['saved-existed']}`]: {
          type: 'val',
          value: true,
        },
      },
    },
  },

  {
    kind: 'api',
    token: 'save-existed',
    spec: {
      uri: `${domen}/v1/tck/bms/invoices/update-batch`,
      method: 'POST',
      ignoreCanceledRequest: true,
      data: {
        app: {
          type: 'func',
          value: '({config}) => config.custom.app',
        },
        token: {
          type: 'func',
          value: '({config}) => config.custom.token',
        },
        timezone: {
          type: 'func',
          value: '({config}) => config.custom.timezone',
        },
        invoices: {
          type: 'func',
          value: `({hashMap}) => {
  const existedInvoces = hashMap['${existedInvocesToken}'].child

  return payloadInvoices = existedInvoces.map(({child}) => {
    const idToken = child.find(({token}) => token.endsWith('_id')).token
    const totalToken = child.find(({token}) => token.endsWith('_price')).token
    const statusToken = child.find(({token}) => token.endsWith('_status')).token

    return {
      id: hashMap[idToken].data.value,
      total: hashMap[totalToken].data.value,
      status: hashMap[statusToken].data.value,
    }
  })
}`,
        },
      },
    },
  },

  {
    kind: 'changes',
    token: 'saveStatus-to-saved-existed',
    spec: {
      target: saveToken,
      changes: {
        'data.customData.saveStatus': {
          type: 'val',
          value: reloadSaveStatuses['saved-existed'],
        },
      },
    },
  },

  {
    kind: 'changes',
    token: 'remove-save-existed-request',
    spec: {
      target: saveToken,
      changes: {
        [`data.customData.${reloadSaveStatuses['saved-existed']}`]: {
          type: 'val',
          value: false,
        },
      },
    },
  },
];
